function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#676767",
  fillRule: "nonzero",
  d: "M11.5 0C5.175 0 0 5.175 0 11.5S5.175 23 11.5 23 23 17.825 23 11.5 17.825 0 11.5 0m0 21.467c-5.482 0-9.967-4.485-9.967-9.967S6.018 1.533 11.5 1.533s9.967 4.485 9.967 9.967-4.485 9.967-9.967 9.967m-.767-12.65h1.534V18.4h-1.534zm1.917-2.684a1.13 1.13 0 0 1-1.15 1.15 1.13 1.13 0 0 1-1.15-1.15c0-.651.499-1.15 1.15-1.15s1.15.499 1.15 1.15"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-info.svg";
export { SvgComponent as ReactComponent };